import React from 'react';
import { Link, browserHistory } from 'react-router';
import {
  ThongTinChung,
  DanhSachCuocThanhTra
} from './sub-view';
import { ContainerFileDinhKem } from 'components/upload';
import moment from 'moment';
import { ThanhTra, Reception, Danhmuc } from 'api';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { ConfirmDialog } from 'modules/dialog';
import { TextMessage } from 'components/tt-forms/common';
import { Button } from '@blueprintjs/core';
import { ShowIf } from 'components/utils';
import { connect } from 'react-redux';
import { MasterLayout } from 'layout';
import { RadioButtonChonTrangThaiKHTT } from 'components/tt-forms';
import { get, isEmpty, concat, isString } from 'lodash';
import { API_URL } from 'constants/config';
import { Dialog } from "@blueprintjs/core";
import { exportExcel } from "constants/exportExcel";

class ThemMoiKeHoachThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isKiemTra: false,
      noiDungError: '',
      maCodeError: '',
      dataFileDinhKem: {
        dieuChinh: [],
        vanBan: []
      },
      inputFileDinhKem: [],
      dataFileDinhKemDelete: [],
      cuocThanhTra: [],
      doiTuongThanhTras: [],
      chucNangCuocThanhTra: '',
      thongTinChung: {},
      thongTinBS: {},
      posting: false,
      titlePage: `Xây dựng kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`,
      oldData: {
        quyetDinhPheDuyetKTTT: ''
      },
      detail: {
        keHoachThanhTraId: '',
        activeTaoCuocThanhTra: false
      },
      removeCuocTTList: [],
      showUpload: false,
      hasChange: false,
      backConfirm: false,
      isSubmit: false,
      tabType: this.props.route.type,
      sendToThanhTra: false,
      activeTaoCuocThanhTra: false,
      thanhTraThanhPhoId: '',
      searchKeyKHTT: '',
      isOpenSearchKHTT: false,
      loading: false,
      trangthaiKHTT: 'NHAP_DU_THAO',
      tableLoading: false,
      hasChangeCuocThanhTra: false,
      isOpen: false,
    }
  }

  componentDidMount() {
    let checkKHDCQD = this.props.location && this.props.location.state && this.props.location.state.keHoachDaCoQuyetDinh;
    if (!checkKHDCQD && (this.props.route.type == 'edit' || this.props.route.type == 'old') && this.props.params && this.props.params.id) {
      this.setState({ titlePage: this.props.route.type == 'edit' ? `Cập nhật kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : 'Thêm mới kế hoạch bổ sung' });
      this.getDetailKHTT(this.props.params.id);
    } else if (checkKHDCQD) {
      this.setState({ titlePage: `Cập nhật kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} đã có quyết định` });
      this.getDetailKHTT(this.props.params.id);
    } else {
      this.setState({ showUpload: true });
    }
    this.checkDonVi();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isKiemTra !== this.state.isKiemTra) {
      let checkKHDCQD = this.props.location && this.props.location.state && this.props.location.state.keHoachDaCoQuyetDinh;
      if (!checkKHDCQD && (this.props.route.type == 'edit' || this.props.route.type == 'old') && this.props.params && this.props.params.id) {
        this.setState({ titlePage: this.props.route.type == 'edit' ? `Cập nhật kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : 'Thêm mới kế hoạch bổ sung' });
      } else if (checkKHDCQD) {
        this.setState({ titlePage: `Cập nhật kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} đã có quyết định` });
      } else {
      }
    }
  }

  checkDonVi() {
    Danhmuc.actions.getThamSo.request(null, { tuKhoa: 'CQQL_THANH_TRA_THANH_PHO' }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ thanhTraThanhPhoId: res.data._embedded.thamSoes.length ? res.data._embedded.thamSoes[0].giaTri : '' });
      }
    });
  }

  checkIsKiemTra() {
    const result = this.props.location.pathname.includes('kiem-tra') || get(this.state, 'isKiemTra');
    return result;
  }

  onFileChange(data, type) {
    const dataFileDinhKem = { ...this.state.dataFileDinhKem };
    if (type === 'DIEU_CHINH_KE_HOACH_THANH_TRA') {
      dataFileDinhKem.dieuChinh = data;
    } else {
      dataFileDinhKem.vanBan = data;
    }
    this.setState({
      dataFileDinhKem,
      hasChange: true
    });
  }

  onFileRemove(id, data) {
    this.state.dataFileDinhKemDelete = [
      ...this.state.dataFileDinhKemDelete,
      id
    ];
    this.state.dataFileDinhKem = data;
    this.state.hasChange = true;
    this.forceUpdate();
  }

  guiThanhTraTP() {
    if (this.validateSubmitForm() && this.checkThongTinKHTT()) {
      this.state.sendToThanhTra = true;
      this.handleSave();
    }
  }

  async taoCuocThanhTra() {
    if (this.validateSubmitForm() && this.checkThongTinKHTT()) {
      await this.setState({
        activeTaoCuocThanhTra: true,
        posting: true
      });
      this.handleSave();
    }
  }

  checkThongTinKHTT() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if ((userInfo.donViId == this.state.thanhTraThanhPhoId ||
      this.state.sendToThanhTra ||
      this.state.activeTaoCuocThanhTra) &&
      !this.state.cuocThanhTra.length
    ) {
      Toastr(`Vui lòng thêm ít nhất một cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}!`, 'warning');
      this.setState({
        sendToThanhTra: false,
        posting: false
      });
      return false;
    } else {
      let pass = true;
      this.state.cuocThanhTra.map(item => {
        if (((item.linhVucThanhTraInfo == null || item.linhVucThanhTraInfo.type == '') && this.state.thongTinChung.chucNangKeHoachThanhTra == 'HANH_CHINH')
          || ((item.hinhThucThanhTraChuyenNganhInfo == null || item.hinhThucThanhTraChuyenNganhInfo.type == '') && this.state.thongTinChung.chucNangKeHoachThanhTra == 'CHUYEN_NGANH')
          || !item.donViChuTriInfo.coQuanQuanLyId) {
          pass = false;
        }
      });

      if (!pass) {
        this.state.isSubmit = true;
        this.setState({ ...this.state });
        return false;
      }
    }
    return true;
  }

  handleSave(name) {
    if (this.checkThongTinKHTT()) {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      const TTTrungUong = 19;
      let params = {
        keHoachThanhTra: {
          activeTaoCuocThanhTra: this.state.activeTaoCuocThanhTra,
          ghiChu: this.state.thongTinChung.ghiChu || '',
          namThanhTra: this.state.thongTinChung.namThanhTra || ((new Date()).getFullYear() + 1),
          nguoiKy: this.state.thongTinChung.nguoiKy || '',
          quyetDinhPheDuyetKTTT: get(this.state.thongTinChung, 'quyetDinhPheDuyetKTTT') || '',
          soVanBanDieuChinh: get(this.state.thongTinChung, 'soVanBanDieuChinh') || undefined,
          ngayQuyetDinhDieuChinh: get(this.state.thongTinChung, 'ngayQuyetDinhDieuChinh') || undefined,
          lyDoDieuChinh: get(this.state.thongTinChung, 'lyDoDieuChinh') || undefined,
          loaiKeHoach: this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA'
        },
      };

      if (userInfo.capCoQuanQuanLyId === TTTrungUong) {
        params.keHoachThanhTra.trangThaiThanhTraTWPheDuyet = this.state.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' ? true : false;
      }

      if (name === 'luuTam') {
        params.sendToThanhTra = false;
      } else {
        params.sendToThanhTra = true;
      }
      if (this.state.cuocThanhTra.length) {
        params.cuocThanhTras = [];
      }

      if (this.state.thongTinChung.chucNangKeHoachThanhTra) {
        params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.thongTinChung.chucNangKeHoachThanhTra;
      }
      if (this.state.thongTinChung.ngayRaQuyetDinh) {
        params.keHoachThanhTra.ngayRaQuyetDinh = moment(this.state.thongTinChung.ngayRaQuyetDinh).toISOString();
      }
      if (this.state.oldData.keHoachThanhTraId) {
        params.keHoachThanhTra.keHoachThanhTraCu = { id: this.state.oldData.keHoachThanhTraId };
        params.keHoachThanhTra.quyetDinhPheDuyetKTTT = this.state.thongTinBS.quyetDinhPheDuyetKTTT || '';
        params.keHoachThanhTra.nguoiKy = this.state.thongTinBS.nguoiKy || '';
        params.keHoachThanhTra.ghiChu = this.state.thongTinBS.ghiChu || '';
        params.keHoachThanhTra.namThanhTra = this.state.oldData.namThanhTra || '';
        if (this.state.oldData.chucNangKeHoachThanhTra) {
          params.keHoachThanhTra.chucNangKeHoachThanhTra = this.state.oldData.chucNangKeHoachThanhTra;
        }
        if (this.state.thongTinBS.ngayRaQuyetDinh) {
          params.keHoachThanhTra.ngayRaQuyetDinh = moment(this.state.thongTinBS.ngayRaQuyetDinh).toISOString();
        }
      }
      this.state.cuocThanhTra.map(item => {
        let itemPushId = [];
        if (!isEmpty(item.doiTuongThanhTraImport)) {
          item.doiTuongThanhTraImport.forEach(doiTuong => {
            itemPushId.push({
              id: doiTuong.id,
            })
          })
        }
        if (item.cuocThanhTraNhieuDoiTuong) {
          if (!item.doiTuongThanhTras) {
            item.listDoiTuongThanhTra.forEach(items => {
              itemPushId.push({
                id: items.doiTuongThanhTraId,
              })
            })
          } else {
            item.doiTuongThanhTras.forEach(items => {
              itemPushId.push({
                id: items.doiTuongThanhTraId || items.id,
              })
            })
          }
        }
        else if (!item.doiTuongThanhTras && item.listDoiTuongThanhTra !== null) {
          item.listDoiTuongThanhTra.forEach(items => {
            itemPushId.push({
              id: items.doiTuongThanhTraId,
            })
          })
        }
        else if (item.cuocThanhTraNhieuDoiTuong === false && (item.doiTuongThanhTras && item.doiTuongThanhTras.length > 0)) {
          item.doiTuongThanhTras.forEach(items => {
            itemPushId.push({
              id: items.doiTuongThanhTraId || items.id,
            })
          })
        }
        let itemParams = {
          ten: item.ten,
          donViChuTriId: item.donViChuTriInfo.coQuanQuanLyId,
          donViPhoiHop: item.donViPhoiHop,
          thoiGianTienHanh: item.thoiGianTienHanh,
          cuocThanhTraNhieuDoiTuong: item.cuocThanhTraNhieuDoiTuong,
          cuocThanhTraMotDoiTuong: item.cuocThanhTraMotDoiTuong,
          doiTuongThanhTras: itemPushId,
          tenNhieuDoiTuongThanhTra: item.tenNhieuDoiTuongThanhTra ? item.tenNhieuDoiTuongThanhTra : '',
          kyThanhTra: item.kyThanhTra,
          linhVucThanhTraList: item.linhVucThanhTraList ? item.linhVucThanhTraList.map(item => isString(item) ? item : item.giaTri) : null,
          chucNangCuocThanhTra: item.chucNangCuocThanhTraInfo && item.chucNangCuocThanhTraInfo.type ? item.chucNangCuocThanhTraInfo.type : null,
          noiDungThanhTra: item.noiDungThanhTra,
          kyTruocChuyenSang: item.kyTruocChuyenSang || false,
          daCoKetQuaDeXuat: false,
          phoiHopXuLy: item.phoiHopXuLy || false,
          thoiHanThanhTra: item.thoiHanThanhTra ? Number(item.thoiHanThanhTra) : 0,
          hinhThucThanhTraChuyenNganh: item.hinhThucThanhTraChuyenNganhInfo && item.hinhThucThanhTraChuyenNganhInfo.type ? item.hinhThucThanhTraChuyenNganhInfo.type : null,
          thucHienPhapLuatVeThanhTraList: item.linhVucThanhTraList && item.linhVucThanhTraList.map(item => isString(item) ? item : item.giaTri).includes('THANH_TRA_TRACH_NHIEM') && item.thucHienPhapLuatVeThanhTraList ? item.thucHienPhapLuatVeThanhTraList.map(item => isString(item) ? item : item.giaTri) : null,
          chiTietLinhVuc: item.chiTietLinhVuc ? item.chiTietLinhVuc : '',
        };

        if (item.id) {
          itemParams.id = item.id;
          this.props.dataDoiTuong.forEach(items => {
            if (items.idCTT === item.id) {
              itemParams.doiTuongThanhTraThemMoiIds = items.arrDoiTuongThemMoi;
              itemParams.doiTuongThanhTraDaXoaIds = items.arrDoiTuongXoa;
            }
          });
          this.props.dataDeXuat.forEach(items => {
            if (items.idDeXuatOld === item.id) {
              itemParams.daCoKetQuaDeXuat = items.hasDeXuatXuLy;
            }
          });
        }
        if (!item.tienDoThanhTraInfo && (item.isOld || item.keHoachThanhTraCuInfo) && this.state.oldData.keHoachThanhTraId) {
          itemParams.resetValue = true;
          itemParams.keHoachThanhTraCu = { id: this.state.oldData.keHoachThanhTraId };
        }
        params.cuocThanhTras.push(itemParams);
      });
      this.setState({ posting: true });
      if (this.state.detail.keHoachThanhTraId) {
        ThanhTra.actions.updateKeHoachThanhTra.request({ id: this.state.detail.keHoachThanhTraId }, params).then(res => {
          if (res && res.data) {
            this.createDSTepDinhKem(res.data);
            this.removeFileDinhKem();
            this.props.dispatch({
              type: 'RESET_DATA'
            });
            Toastr(this.checkIsKiemTra() ? msg.updateKHKTSuccess : msg.updateKHSuccess, 'success');
            setTimeout(() => {
              browserHistory.goBack();
            }, 1000);
          }
          if (this.state.removeCuocTTList.length) {
            ThanhTra.actions.deleteCuocThanhTraKHTT.request({ id: this.state.detail.keHoachThanhTraId }, { cuocThanhTras: this.state.removeCuocTTList }).then(res => {
            });
          }
          this.setState({ posting: false });
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({ posting: false });
        });
      } else if (params.keHoachThanhTra.keHoachThanhTraCu) {
        ThanhTra.actions.postKeHoachThanhTra.request(null, params).then(res => {
          if (res && res.data) {
            this.createDSTepDinhKem(res.data);
            this.props.dispatch({
              type: 'RESET_DATA'
            });
            Toastr(this.checkIsKiemTra() ? msg.createKHKTSuccess : msg.createKHSuccess, 'success');
            setTimeout(() => {
              browserHistory.goBack();
            }, 1000);
          }
          this.setState({ posting: false });
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({ posting: false });
        });
      } else {
        let d = new Date();
        let getNam = d.getFullYear() + 1;
        ThanhTra.actions.getValidateKeHoachThanhTra.request({
          id: '',
          namThanhTra: getNam,
          isKeHoachBoSung: false,
          loaiKeHoach: this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA'
        }).then(res => {
          if (res && res.status === 204) {
            ThanhTra.actions.postKeHoachThanhTra.request(null, params).then(res => {
              if (res && res.data) {
                this.createDSTepDinhKem(res.data);
                this.props.dispatch({
                  type: 'RESET_DATA'
                });
                Toastr(this.checkIsKiemTra() ? msg.createKHKTSuccess : msg.createKHSuccess, 'success');
                setTimeout(() => {
                  browserHistory.goBack();
                }, 1000);
              }
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail, 'error');
              }
              this.setState({ posting: false });
            });
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
            this.setState({ posting: false });
          }
        });
      }
    }
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = [];
    let data = this.state.dataFileDinhKem;

    if (!isEmpty(data.dieuChinh)) {
      dataFileDinhKem = concat(dataFileDinhKem, data.dieuChinh);
    }
    if (!isEmpty(data.vanBan)) {
      dataFileDinhKem = concat(dataFileDinhKem, data.vanBan);
    }
    return dataFileDinhKem;
  }

  createDSTepDinhKem(data) {
    let listAddNew = [];
    let listUpdate = [];
    let dataFileDinhKem = this.getListDataFileDinhKem();
    if (!isEmpty(dataFileDinhKem)) {
      dataFileDinhKem.map((item, i) => {
        if (item.ten && item.duongDan) {
          let params = {
            keHoachThanhTra: { id: data.keHoachThanhTraId },
            loaiQuyTrinh: item.phanLoaiQuyTrinh === 'DIEU_CHINH_KE_HOACH_THANH_TRA' || item.loaiQuyTrinh === 'DIEU_CHINH_KE_HOACH_THANH_TRA' ? 'DIEU_CHINH_KE_HOACH_THANH_TRA' : 'KE_HOACH_THANH_TRA',
            nhomHoSo: item.nhomHoSo ? {
              id: Number(item.nhomHoSo)
            } : get(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: get(item, 'nhomHoSoInfo.nhomHoSoId') } : null
          }
          if (item.ten) {
            params.ten = item.ten;
          }
          if (item.tenFile) {
            params.tenFile = item.tenFile;
          }
          if (item.duongDan) {
            params.duongDan = item.duongDan;
          }
          if (item.typeRequired) {
            params.typeRequired = item.typeRequired;
          }
          if (item.required) {
            params.required = item.required;
          }
          if (item.soQuyetDinh) {
            params.soQuyetDinh = item.soQuyetDinh;
          }
          if (item.ngayQuyetDinh) {
            params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
          }
          if (item.taiLieuVanThuId) {
            params.id = item.taiLieuVanThuId;
            listUpdate.push(params);
          } else {
            listAddNew.push(params);
          }
        }
      });
      if (listAddNew.length) {
        Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
      }
      if (listUpdate.length) {
        Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
      }
    }
  }

  removeFileDinhKem() {
    this.state.dataFileDinhKemDelete.map(item => {
      Reception.actions.deleteTepDinhKem.request({
        id: item
      });
    });
  }

  handleChangeThongTinChung(data) {
    this.setState({
      thongTinChung: data,
      hasChange: true
    });
  }

  handleChangeThongTinBS(data, isInit) {
    this.state.thongTinBS = data;
    if (!isInit) {
      this.state.hasChange = true;
    }
    this.setState({ ...this.state });
  }

  handleChangeCuocThanhTra(data) {
    this.setState({
      cuocThanhTra: data,
      hasChange: true,
      isSubmit: false,
      hasChangeCuocThanhTra: true
    });
  }

  handleRemoveCuocTT(idCTT) {
    this.state.removeCuocTTList.push({ id: idCTT });
    this.setState({ ...this.state });
  }

  validateSubmitForm() {
    let pass = true;
    this.state.isSubmit = true;
    this.setState({ ...this.state });
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleBack(allowBack) {
    if (allowBack) {
      this.props.dispatch({ type: 'DSTT_GO_BACK' });
      this.props.dispatch({ type: 'RESET_DATA' });
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({ ...this.state });
      } else {
        this.props.dispatch({ type: 'DSTT_GO_BACK' });
        this.props.dispatch({ type: 'RESET_DATA' });
        this.props.dispatch({ type: 'RESET_DEXUAT' });
        browserHistory.goBack();
      }
    }
  }

  getDetailKHTT(idKH) {
    this.setState({ loading: true });
    ThanhTra.actions.getKeHoachThanhTraDetail.request({ id: idKH }).then(res => {
      if (res.data) {
        if (this.props.route.type == 'old') {
          res.data.cuocThanhTras.map(item => {
            item.isOld = true;
          });
          this.state.oldData = res.data;
          this.state.cuocThanhTra = res.data.cuocThanhTras;
        } else {
          this.state.detail = res.data;
          this.state.cuocThanhTra = res.data.cuocThanhTras;
          if (res.data.keHoacThanhTraCuInfo) {
            this.state.thongTinBS = res.data;
            this.state.oldData = res.data.keHoacThanhTraCuInfo;
            this.state.tabType = 'old';
          } else {
            this.state.thongTinChung = res.data;
          }
          this.state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
          this.state.saveTamKeHoachTT = res.data.saveTamKeHoachTT
        }
        if (res.data.trangThaiThanhTraTWPheDuyet === true) {
          this.state.trangthaiKHTT = 'NHAP_KHTT_PHE_DUYET';
        }
        this.state.showUpload = true;
        res.data.listTaiLieuVanThu.map((item, i) => {
          this.state.inputFileDinhKem[i] = {
            taiLieuVanThuId: item.taiLieuVanThuId,
            ten: item.ten,
            tenFile: item.tenFile,
            required: item.required || false,
            duongDan: item.duongDan,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).toISOString() : '',
            soQuyetDinh: item.soQuyetDinh || '',
            loaiTepDinhKem: item.loaiTepDinhKem || '',
            nhomHoSoInfo: item.nhomHoSoInfo || null
          };
        });
        this.setState({ ...this.state, isKiemTra: get(res, 'data.loaiKeHoach.value') === 'KIEM_TRA' });
      }
      this.setState({ loading: false });
    }).catch(err => {
      this.setState({ loading: false });
    });
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({ ...this.state });
  }
  onChange(name, e) {
    this.setState({ [name]: e.target.value });
  }

  componentWillUnmount() {

  }

  toggleDialog(name, status) {
    this.state[name] = status;
    this.setState({ ...this.state });
  }
  viewAllKeHoachTT(searchKey) {
    this.state.searchKeyKHTT = searchKey;
    this.toggleDialog('isOpenSearchKHTT', true);
  }
  handleClose() {
    this.props.dispatch({ type: 'DSTT_GO_BACK' })
    browserHistory.goBack();
  }

  handleChangeTrangThaiKHTT(e) {
    this.setState({
      trangthaiKHTT: e.target.value,
    });
  }

  handleHoanThanh() {
    if (this.validateSubmitForm()) {
      this.handleSave();
    }
  }

  handleExport() {
    if (this.state.hasChangeCuocThanhTra) {
      this.setState({
        isOpen: true
      });
    } else {
      const { detail } = this.state;
      const keHoachId = get(detail, 'keHoachThanhTraId');
      let URL = `${String(API_URL)}/keHoachThanhTras/cuocThanhTras/xuatExcel?id=${keHoachId}`;
      exportExcel(URL, 'danh-muc-cuoc-thanh-tra.xlsx');
    }
  }

  closeDialog() {
    this.setState({
      isOpen: false
    });
  }

  render() {
    let getThongTinKHTTDCQD = this.props.location && this.props.location.state;
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let displayButtonCreate = (this.state.detail.saveTamKeHoachTT == false || this.state.tabType == 'old') &&
      (this.state.thongTinChung.quyetDinhPheDuyetKTTT || this.state.thongTinBS.quyetDinhPheDuyetKTTT) &&
      (this.state.thongTinChung.ngayRaQuyetDinh || this.state.thongTinBS.ngayRaQuyetDinh) &&
      this.state.activeTaoCuocThanhTra == false;
    let displayButtonSent = (Number(userInfo.donViId) !== Number(this.state.thanhTraThanhPhoId)) && (this.state.sendToThanhTra === false) && this.state.tabType !== 'old';
    const TTTrungUong = 19;
    const { detail } = this.state;
    const isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong ? true : false;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container panel-page">
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
            title={msg.confirmBack} />
          <Dialog
            isOpen={this.state.isOpen}
            onClose={this.closeDialog.bind(this, 'isOpen')}
            title='Thông báo'
            className="reception-dialog delete-dialog wrap-block"
          >
            <div className="pt-dialog-body">
              <p className="reception-dialog-text">Bạn cần lưu những thay đổi trước khi xuất file excel</p>
            </div>
            <div className="pt-dialog-footer">
              <div className="pt-dialog-footer-actions reception-delete-confirm">
                <Button
                  onClick={this.closeDialog.bind(this)}
                  text="Đóng"
                  className="btn-default"
                />
              </div>
            </div>
          </Dialog>
          <div className="back-foward">
            <Link onClick={this.handleClose.bind(this)} title="">Về trang trước</Link>
          </div>
          <div className="heading tttu-content">
            <h2 className="heading-title icon-add">
              {this.state.titlePage}
            </h2>
            {
              isTTTW && this.state.tabType === 'new' &&
              <div className='tttu-right-content'>
                <RadioButtonChonTrangThaiKHTT disable={this.state.tableLoading} selectedValue={this.state.trangthaiKHTT} onChange={this.handleChangeTrangThaiKHTT.bind(this)} />
              </div>
            }
          </div>
          <div className="bottom-content main_page">
            <ThongTinChung isKiemTra={this.checkIsKiemTra()} isTTTW={isTTTW} bindValidator={this} trangthaiKHTT={this.state.trangthaiKHTT} keHoach={getThongTinKHTTDCQD} onChange={this.handleChangeThongTinChung.bind(this)} onChangeBS={this.handleChangeThongTinBS.bind(this)} dataDC={this.state.thongTinChung} data={this.state.detail} tabType={this.state.tabType} onFileChange={this.onFileChange.bind(this)} onFileRemove={this.onFileRemove.bind(this)} />
            <div className='row pl30 pr30'>
              <span className='line-border mt5 mb20'></span>
            </div>
            <ShowIf condition={this.state.tabType == 'old'}>
              <section className='wrap-block'>
                <div className='row pl10 pr10'>
                  <h2 className='title-13 col-100 pl20 pr20 pb15'>{`1.1 Thông tin kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} cũ`}</h2>
                </div>
                {
                  this.state.oldData.quyetDinhPheDuyetKTTT != '' ?
                    <div className='row pl25 pr25'>
                      <TextMessage
                        label="Quyết định phê duyệt KHTT:"
                        value={this.state.oldData.quyetDinhPheDuyetKTTT || ''} />
                      <TextMessage
                        label="Ngày phê duyệt:"
                        value={this.state.oldData.ngayRaQuyetDinh ? moment(this.state.oldData.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                      <TextMessage
                        label={`Năm ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`}
                        value={this.state.oldData.namThanhTra || ''} />
                      <TextMessage
                        label="Người ký:"
                        value={this.state.oldData.nguoiKy || ''} />
                    </div>
                    : ''
                }
              </section>
              <div className='row pl30 pr30'>
                <span className='line-border mt5 mb20'></span>
              </div>
            </ShowIf>
            <DanhSachCuocThanhTra
              keHoach={getThongTinKHTTDCQD}
              namKeHoachThanhTra={this.state.thongTinChung.namThanhTra ? this.state.thongTinChung.namThanhTra : this.state.oldData.namThanhTra}
              bindValidator={this}
              onRemove={this.handleRemoveCuocTT.bind(this)}
              tabType={this.state.tabType}
              onChange={this.handleChangeCuocThanhTra.bind(this)}
              data={this.state.detail}
              oldData={this.state.oldData}
              isSubmit={this.state.isSubmit}
              chucNangKeHoachThanhTra={this.state.thongTinChung.chucNangKeHoachThanhTra}
              handleExport={this.handleExport.bind(this)}
              isKiemTra={this.checkIsKiemTra()}
            />
            <div className='row pl15 pr15'>
              <span className='big-border mt5 mb20'></span>
            </div>
            {
              this.state.showUpload ?
                <div className='row pl30 pr30 '>
                  <ContainerFileDinhKem isDsVanBanXuLy label="2. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} bindValidator={this} data={this.state.inputFileDinhKem} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                </div>
                : ''
            }

          </div>
          <div className="pt35 pb5">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={this.handleBack.bind(this, false)}><span>Đóng</span></Button>
              <ShowIf condition={!get(getThongTinKHTTDCQD, 'keHoachDaCoQuyetDinh')}>
                <Button type="button" className={`btn-action btn-save btn-green ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.handleSave.bind(this, 'luuTam')}>Lưu tạm</Button>
              </ShowIf>
              <ShowIf condition={(displayButtonCreate && this.state.loading == false) || this.state.trangthaiKHTT === 'NHAP_KHTT_PHE_DUYET' && get(detail, 'trangThaiKeHoachThanhTra') !== "DA_CO_QUYET_DINH"}>
                <Link style={{ right: 0 }} className={`btn-action btn-green warning right ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.taoCuocThanhTra.bind(this)}><i className="tt tt-addfile"></i><span>Triển khai KHTT</span></Link>
              </ShowIf>
              <ShowIf condition={displayButtonSent && this.state.loading == false && this.state.trangthaiKHTT !== 'NHAP_KHTT_PHE_DUYET' && get(detail, 'trangThaiKeHoachThanhTra') !== "CHO_RA_QUYET_DINH" && get(detail, 'trangThaiKeHoachThanhTra') !== "DA_CO_QUYET_DINH"}>
                <Button type="button" style={{ right: 0 }} className={`btn-action btn-move btn-green right ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.guiThanhTraTP.bind(this)}>Gửi Thanh tra tỉnh</Button>
              </ShowIf>
              <ShowIf condition={this.state.tabType === 'edit' && get(detail, 'trangThaiKeHoachThanhTra') === "DA_CO_QUYET_DINH"}>
                <Button type="button" style={{ right: 0 }} className={`btn-action btn-move btn-green right ${this.state.posting ? 'btn-loading-inline' : ''}`} onClick={this.handleHoanThanh.bind(this)}>Hoàn thành</Button>
              </ShowIf>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

ThemMoiKeHoachThanhTra.defaultProps = {
  validators: {},
  dataDoiTuong: []
}

function bindStateToProps(state) {
  return {
    dataDeXuat: state.dataCuocThanhTra.dataDXOld,
    dataDoiTuong: state.dataCuocThanhTra.dataDoiTuong
  };
}

export default connect(bindStateToProps)(ThemMoiKeHoachThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/ThemMoiKeHoachThanhTra.jsx